import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITask, ITaskState } from './types/Task-interface';
import { fetchFileDownload, fetchTaskCase } from './actions/fetch-task-case';

const initialState: ITaskState = {
    Task: {
        Date: "",
        Number: "",
        AuthorsComment: "",
        ResponsiblesComment: "",
        AuthorsExpectedCompletionDate: "",
        StatusName: "",
        ThemeName: "",
        Files: [],
        StatusHistory: []
    },
    isLoadingTask: false,
    errorTask: [],
    lastFetchTime: null,
    TaskID: "",
    isDownload: false,
    errorDownload: [],
    FileData: "",
    FileName: ""
};

export const Task = createSlice({
    name: 'Task',
    initialState,
    reducers: {
        resetTaskData: (state) => {
            state.Task = initialState.Task;
            state.isLoadingTask = false;
            state.errorTask = [];
            state.lastFetchTime = null;
            state.TaskID = "";
            state.isDownload = false;
            state.errorDownload = [];
            state.FileData = "";
            state.FileName = "";
        },
        resetFileData: (state) => {
            state.Task = state.Task;
            state.isLoadingTask = state.isLoadingTask;
            state.errorTask = state.errorTask;
            state.lastFetchTime = state.lastFetchTime;
            state.TaskID = state.TaskID;
            state.isDownload = false;
            state.errorDownload = [];
            state.FileData = "";
            state.FileName = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTaskCase.pending, (state) => {
                state.isLoadingTask = true;
            })
            .addCase(fetchTaskCase.fulfilled, (state, action: PayloadAction<{ task: ITask, fetchTime: number, TaskID: string }>) => {
                state.isLoadingTask = false;
                state.Task = action.payload.task;
                state.errorTask = [];
                state.lastFetchTime = action.payload.fetchTime;
                state.TaskID = action.payload.TaskID;
            })
            .addCase(fetchTaskCase.rejected, (state, action) => {
                state.Task = initialState.Task;
                state.isLoadingTask = false;
                state.errorTask = action.payload as string[];
                state.TaskID = "";
            })
            .addCase(fetchFileDownload.pending, (state) => {
                state.isDownload = true;
            })
            .addCase(fetchFileDownload.fulfilled, (state, action: PayloadAction<{ FileData: string, FileName: string }>) => {
                state.isDownload = false,
                state.errorDownload = [];
                state.FileData = action.payload.FileData;
                state.FileName = action.payload.FileName;
            })
            .addCase(fetchFileDownload.rejected, (state, action) => {
                state.isDownload = false,
                state.errorDownload = action.payload as string[];
                state.FileData = "";
                state.FileName = "";
            });
    },
});

export const { resetTaskData, resetFileData } = Task.actions;
export default Task.reducer;